import { KeyTag, KeyTagGroup } from './KeyTag'
import Text from './Text'
import Wrapper from './Wrapper'

export default {
  Wrapper,
  KeyTag,
  KeyTagGroup,
  Text,
}
